import React from "react";
import { useNavigate } from "react-router-dom";

export default function SubscribeModal({ open, onClose }) {
  const nav = useNavigate();
  if (!open) return null;

  const goCheckout = (plan) => {
    onClose?.();
    nav(`/subscribe/checkout?plan=${encodeURIComponent(plan)}`);
  };

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", gap: 12 }}>
          <div>
            <h2 style={{ margin: 0 }}>Subscribe to Element Match</h2>
            <p style={{ margin: "8px 0 0", opacity: 0.85 }}>
              See your <b>Chinese Element</b> + detailed reading and compatibility.
            </p>
          </div>
          <button onClick={onClose} aria-label="Close" style={xBtn}>✕</button>
        </div>

        <div style={{ display: "grid", gap: 12, marginTop: 16 }}>
          <button style={planBtn} onClick={() => goCheckout("monthly")}>
            <div style={{ fontWeight: 900, fontSize: 16 }}>$5 / month</div>
            <div style={{ fontSize: 12, opacity: 0.9 }}>Most popular</div>
          </button>

          <button style={planBtn} onClick={() => goCheckout("yearly")}>
            <div style={{ fontWeight: 900, fontSize: 16 }}>$10 / year</div>
            <div style={{ fontSize: 12, opacity: 0.9 }}>Best value</div>
          </button>

          <button style={planBtn} onClick={() => goCheckout("lifetime")}>
            <div style={{ fontWeight: 900, fontSize: 16 }}>$20 lifetime</div>
            <div style={{ fontSize: 12, opacity: 0.9 }}>One-time payment</div>
          </button>
        </div>

        <p style={{ marginTop: 14, fontSize: 13, opacity: 0.75 }}>
          Secure payment via Stripe. Cancel anytime (monthly/yearly).
        </p>
      </div>
    </div>
  );
}

const overlay = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.65)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
  padding: 16,
};

const modal = {
  width: "min(720px, 96vw)",
  background: "#fff",
  borderRadius: 18,
  padding: 18,
  boxShadow: "0 20px 50px rgba(0,0,0,0.35)",
};

const planBtn = {
  width: "100%",
  textAlign: "left",
  padding: "14px 16px",
  borderRadius: 16,
  border: "1px solid rgba(0,0,0,0.08)",
  background: "#920b01",    
  color: "#fff",
  cursor: "pointer",
};

const xBtn = {
  border: "none",
  background: "#f3f3f3",
  borderRadius: 10,
  width: 36,
  height: 36,
  cursor: "pointer",
  fontWeight: 900,
};
